import { render, staticRenderFns } from "./DeleteRate.vue?vue&type=template&id=cc7f39fe"
import script from "./DeleteRate.vue?vue&type=script&lang=js"
export * from "./DeleteRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports